import {
    Box,
    SwipeableDrawer,
    Typography, } from '@mui/material';
import { useAppbar, } from '../../../hooks';
import AccordionMenu from './AccordionMenu';
import AccordionLibrary from './AccordionLibrary';
import AccordionCreate from './AccordionCreate';

export default function SwipeableTemporaryDrawerMenu({ pages, }) {
    const { drawerMenuIsOpen, drawerMenuOpen, drawerMenuClose, } = useAppbar();

    const accordionStyles = {
        border: 1,
        borderColor: 'borderColor.main',
    };

    return (<SwipeableDrawer
            open={drawerMenuIsOpen}
            onClose={drawerMenuClose}
            onOpen={drawerMenuOpen}
            sx={{
                '& .MuiPaper-root': {
                    backgroundImage: 'none',
                },
            }}>
        <Box component='nav' sx={{ minWidth: [240, 432, 577,], p: 2.5, }}>
            <Typography component='h2' variant='logo' sx={{ mb: 2, textAlign: 'center', }}>меню</Typography>
            <AccordionMenu
                pages={pages}
                sx={{ mb: 1.5, ...accordionStyles, }} />
            <AccordionLibrary sx={{ mb: 1.5, ...accordionStyles, }} />
            <AccordionCreate
                sx={{...accordionStyles,}} />
        </Box>
    </SwipeableDrawer>);
};